export default "__VITE_ASSET__BSWGvWwL__"